import { z } from "zod/v4-mini";

import { FileModel, fileSchema } from "@/models/FileModel.ts";
import { DeviceType, deviceTypeSchema } from "@/models/MedicalDeviceModel.ts";
import { Schema, cz } from "@/utils/zodUtils.ts";

export type DailyFileReport = {
  id: string;
  patientId: string;
  date: string;
  deviceId?: string;
  deviceType?: DeviceType;

  reportType: "medtronic_report";
  file: FileModel;
};

export const dailyFileReportSchema: Schema<DailyFileReport> = cz.camelCaseObject({
  id: cz.id(),
  patient_id: z.string(),
  date: z.iso.date(),
  device_id: cz.optional(cz.id()),
  device_type: cz.optional(deviceTypeSchema),
  report_type: z.literal("medtronic_report"),
  file: fileSchema,
});
